import React from 'react';
import { Form, Col, Row, Button } from 'react-bootstrap';
import axios, { AxiosRequestConfig } from 'axios';
import { Constants } from "../../constants";
import SiteMenu from "../menu";
import '../../App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import OrderInquiryBasicInfo from '../orders/order_inquiry_basic_info';
import ReactGA from "react-ga4"

class ContractRenewalRequest extends React.Component {
    constructor(props) {
        super(props);

        let userExists = !(props.location.state == null || props.location.state.user == null);

        console.log(props);
        this.state = {
            user: userExists ? props.location.state.user : {},
            input: props.location.state.data,
            errors: {}
        };

        /*this.createSelectItems = this.createSelectItems.bind(this);*/
        this.handleFormChange = this.handleFormChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    componentDidMount() {
        /*axios.get(`${Constants.apiURL}/api/Payment/accounts`, {
            params: {
                username: this.state.user.username
            }
        }).then(response => {
            if (response.data) {

                this.setState(() => ({
                    accounts: response.data
                }));
            }
        }).catch((response) => {
            // ? Show to user that request is failed
            this.setState({ errors: [response] })
            this.setState({ loading: false });
            console.log('request failed', response)
        });*/
    }

    handleFormChange(event) {
        let input = this.state.input;
        let errors = this.state.errors;
        input[event.target.name] = event.target.value;
        if (!!errors[event.target.name]) {
            errors[event.target.name] = null;
        }

        this.setState({
            input,
            errors
        });
    }

    validate() {
        let input = this.state.input;
        let errors = {};
        let isValid = true;

        if (!input["RenewalNotes"]) {
            isValid = false;
            errors["RenewalNotes"] = "Invalid.";
        }

        this.setState({
            errors: errors
        });

        return isValid;
    }

    handleSubmit(event) {

        event.preventDefault();
        if (!this.validate()) {
            alert('Please fill in required fields to proceed.');
            return;
        }

        let formData = new FormData();
        for (var key in this.state.input) {
            formData.append(key, this.state.input[key]);
        }
        for (var key in this.state.user) {
            formData.append(key, this.state.user[key]);
        }

        this.setState({ loading: true });


        axios.post(`${Constants.apiURL}/api/Request/renewal`, formData, {
            headers: { 'Content-Type': 'multipart/form-data' }
        }).then(response => {
            console.log(response);
            if (response.data && response.data == true) {
                ReactGA.event({
                    category: 'Request',
                    action: 'ContractRenewal',
                    label: 'Contract Renewal Request'
                });
                alert('Your renewal request has been received. A member of our team will be in touch soon!');
                this.props.history.push({
                    pathname: '/orders',
                    state: {
                        user: this.state.user
                    }
                });
            }
            else {
                alert('Error processing your request');
            }
            this.setState({ loading: false });
        }).catch((response) => {
            // ? Show to user that request is failed
            this.setState({ errors: [response] })
            this.setState({ loading: false });
            console.log('request failed', response)
        });
    }

    render() {
        return (
            <div>
                <SiteMenu user={this.state.user} currentPage='contractRenewal' />
                <Form.Label style={{ margin:3, marginLeft:10 }} className="form-header">Contract Renewal Request</Form.Label>
                <OrderInquiryBasicInfo style={{ margin: 5 }} data={this.state.input} />
                <Form>
                    <Row style={{ margin: 5 }} >
                        <Col md={6}>
                            <Form.Group as={Row} className="mb-3" >
                            <Form.Label column md={2} >Renewal Notes</Form.Label>
                            <Col md={10}>
                                    <Form.Control as="textarea" rows={3} name="RenewalNotes" value={this.state.input.RenewalNotes} onChange={this.handleFormChange}
                                        isInvalid={!!this.state.errors.RenewalNotes} />
                            </Col>
                            </Form.Group>
                        </Col>
                    </Row>
                </Form>
                <Button style={{ marginLeft: '10px', backgroundColor: '#1F419B' }} variant="primary" type="submit" onClick={this.handleSubmit}>
                    Submit
                </Button>
            </div>
        );
    }
}

export default ContractRenewalRequest;